// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2X_WN","icon":"SortAdornment_icon__Lx0Pc","up":"SortAdornment_up__1HjDp","down":"SortAdornment_down__ua6wc","active":"SortAdornment_active__1MmPB"};